import { StyleSheet } from "react-native";

export const sellScreenSummaryStyle = StyleSheet.create({
    summaryOuterView: {
        flex: 1,
        padding: 10
    },
    discountView: {
        flexDirection: "row",
        justifyContent: "space-between"
    },
    firstCardView: {
        flexDirection: "row",
        alignItems: "center",
        width: "45%",
        gap: 10
    },
    secondCardView: {
        flexDirection: "row",
        alignItems: "center",
        width: "50%",
        justifyContent: "flex-end",
        gap: 10
    },
    thirdCardView: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
    },
    checkoutSummaryContainer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
    },
    checkoutSummaryInnerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    paymentOuterView: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1,
    }
})